<template>
  <div class="col-lg-3 col-md-4 col-6" :key="component.slug">
      <div class="product_box text-center ">
          <span class="pr_flash bg-success" v-if="component.type == 'package'">HOT</span>
          <div class="product_img">
              <a :href="component.url_link">
                    <img :src="component.thumbnail" :alt="component.name">
              </a>
              <div class="product_action_box">
                  <ul class="list_none pr_action_btn">
                      <li v-if="component.type == 'randomPrice'"><a @click="handleConfirm(component)"><i class="icon-heart"></i></a></li>
                      <li v-else><a :href="component.url_link"><i class="icon-heart"></i></a></li>
                  </ul>
              </div>
          </div>
          <div class="product_info">
              <h6 v-if="component.type == 'randomPrice'" class="product_title"><a @click="handleConfirm(component)">{{ component.name }}</a></h6>
              <h6 v-else class="product_title"><a :href="component.url_link">{{ component.name }}</a></h6>
              <div class="product_price" v-if="component.type == 'randomPrice'">
                  <span class="price">{{ Helper.formatMoney(component.price) }}đ/Lượt</span>
              </div>
              <div class="product_price" v-if="component.type == 'package'">
                  <span class="price">Đã bán: {{ Helper.formatMoney((component.sold_account_count * 13) + (component.created_day_count * 115)) }}</span>
              </div>
              <div class="product_price" v-if="component.type == 'wheel'">
                  <span class="price"> {{ Helper.formatMoney(parseFloat(component.price.toString())) }} đ</span>
              </div>
              <div class="product_price" v-if="component.type == 'luckyBox'">
                  <span class="price">{{ Helper.formatMoney(component.price) }}đ / Lượt</span>
              </div>
              <div class="rating_wrap">
                  <div class="rating"> <div class="product_rate" style="width:100%"></div> </div>
                  <br />
                  <a :href="component.url_link" class="btn btn-fill-out btn-radius">{{ component.btnText }}</a>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name:"ComponentItem",
  props:{
      component:{}
  },
  methods:{
      async handleConfirm(price) {
          await this.$swal.fire({
              title: 'Bạn có muốn thử vận may?',
              imageUrl: price.thumbnail,
              html: price.content,
              showDenyButton: true,
              showCancelButton: true,
              confirmButtonText: `Thử ngay`,
              denyButtonText: `Huỷ`,
          }).then((result) => {
              if (result.isConfirmed) {
                  this.handleBuyRandomAccount(price);
              }
          })
      },
  }
}
</script>